<template>
	<div id="page">



		<div class="page-content">

			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>فراموشی رمز عبور</h2>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style" v-show="step==1">
				<div class="content mt-2 mb-0">
					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">آدرس ایمیل یا شماره تلفن همراه</span>
						<input v-model="userInput" @blur="v$.userInput.$touch()" :class="{invalid:v$.userInput.$error}">
						<p class="text-danger" v-if="v$.userInput.required.$invalid && v$.userInput.$dirty">لطفا آدرس ایمیل یا شماره تلفن همراه خود را وارد کنید</p>
					</div>
					<button :disabled="v$.userInput.required.$invalid" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="getResetLink">ثبت</button>

				</div>

			</div>

			<div class="card card-style" v-show="step==2">
				<div class="content mt-2 mb-0">
					<p>لطفا کد ارسال شده به شماره {{phoneNumber}} را وارد کنید.</p>
					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">کد فعالسازی</span>
						<input type="tel" v-model="registCode" @blur="v$.registCode.$touch()" :class="{invalid:v$.registCode.$error}">
						<p class="text-danger" v-if="v$.registCode.requiredIfFuction.$invalid && v$.registCode.$dirty">لطفا کد فعالسازی را وارد کنید</p>
					</div>
					<button disabled id="resendButton" class="text-right btn btn-default" @click.prevent="GetRegistCode" href="#" type="button">ارسال مجدد کد</button>
					<button :disabled="v$.registCode.requiredIfFuction.$invalid || Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="ValidateCode">ثبت</button>

				</div>

			</div>

			<div class="card card-style" v-if="step==3">
				<div class="content mt-2 mb-0">
					<p>لطفا رمز عبور جدید خود را وارد کنید: </p>
					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">رمز عبور جدید</span>
						<input type="password" v-model="password" @blur="v$.password.$touch()" :class="{invalid:v$.password.$error}">
						<p class="text-danger" v-if="v$.password.required.$invalid && v$.password.$dirty">لطفا رمز عبور جدید را وارد کنید</p>
						<p class="text-danger" v-if="v$.password.minLength.$invalid && v$.password.$dirty">رمز عبور می بایست حداقل ۶ کاراکتر باشد.</p>

					</div>

					<div class="input-style input-style-2 has-icon input-required mt-4">
						<i class="input-icon fa fa-lock"></i>
						<span class="color-highlight input-style-1-active input-style-1-inactive">تکرار رمز عبور </span>
						<input type="password" v-model="confirmPassword" @blur="v$.confirmPassword.$touch()" :class="{invalid:v$.confirmPassword.$error}">
						<p class="text-danger" v-if="v$.confirmPassword.required.$invalid && v$.confirmPassword.$dirty">لطفا تکرار رمز عبور را وارد کنید</p>
						<p class="text-danger" v-if="v$.confirmPassword.sameAsPassword.$invalid && v$.confirmPassword.$dirty">رمز عبور جدید و تکرار آن باهم مطابقت ندارند.</p>
					</div>

					<button :disabled="v$.confirmPassword.$error || v$.password.$error || Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="SavePassword">ثبت</button>

				</div>
			</div>

			<div class="card card-style" v-show="step==4">
				<div class="content mt-2 mb-0">
					<p>لینک بازیابی رمز عبور به آدرس ایمیل {{email}} ارسال شد.</p>
					
					<!-- <button disabled id="resendButton" class="text-right btn btn-default" @click.prevent="GetRegistCode" href="#" type="button">ارسال مجدد کد</button> -->

				</div>

			</div>
		</div>
			<!-- end of page content-->

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
	</div>
</template>
<script>

import useVuelidate from '@vuelidate/core'
	import {
        required, sameAs, minLength,requiredIf
	} from "@vuelidate/validators";

	export default {
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				userInput:"",
				password: "",
				confirmPassword:"",
				oldPassword: "",
				phoneNumber:"",
				registCode:"",
				step: 1,
                Loading:false,
				email:""
			};
		},
		
		methods: {
            SavePassword() {
                this.Loading = true;
                this.$http.get('Account/SaveNewPassword?phoneNumber='+this.phoneNumber+'&registCode='+ this.registCode+'&pass='+ this.password).then(response => {
                    console.log(response);
                    if (response.data !== null && response.data.userId>0) {
                        const login = {
                            phoneNumber: this.phoneNumber,
                            password: this.password
                        };
                        this.Loading = true;
						this.$store.dispatch("LoginUser", login);
                        this.Loading = true;
                    }
                    else {
						this.showErrorMessage(response.data);
                        this.Loading = false;
                    }
                   
                }, data => {
                    console.log(data);
                });
            },
			getResetLink()
			{
				if(this.validateEmail(this.userInput))
				{
				this.email=this.userInput;
				this.SendResetEmail();
				}
				else{
					this.phoneNumber=this.userInput;
					this.GetRegistCode();
				}
			},
			GetRegistCode() {
				this.Loading = true;
				this.$http.get('Account/ResendSms?phoneNUmber='+this.phoneNumber ).then(response => {
                    console.log(response);
					if (response.data == 1) {
						this.step = 2;
						this.setTimer();
                    }
					else {
						this.showErrorMessage(response.data);
						console.log(response);
					}
                    this.Loading = false;
                }, data => {
                    console.log(data);
                });
			},
			SendResetEmail()
			{
				this.Loading = true;
				this.$http.get('Account/ResendEmail?email='+this.email+"&isForgotPass=true" ).then(response => {
                    console.log(response);
					if (response.data == 1) {
						this.step = 4;
                    }
					else {
						this.showErrorMessage(response.data);
						console.log(response);
					}
                    this.Loading = false;
                }, data => {
                    console.log(data);
                });
			},
            ValidateCode() {
                this.Loading = true;
                this.$http.post('Account/ValidateCode?phoneNumber=' + this.phoneNumber + '&registCode=' + this.registCode+"&pass="+this.password).then(response => {
                    console.log(response);
                    if (response.status == 400 || response.data.success == false) {
                        var res = response.data.errors.map(a => a.errorMessage);
                        this.showErrorMessage(res.join('\n'));
                    }
                    else {
                        this.step = 3;
                    }
                    this.Loading = false;
                }, data => {
                    console.log(data);
                }, error => {
                    console.log(error);
                });
			},
			validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
},
            setTimer() {
        var timer2 = "5:00";
        var interval = setInterval(function () {
            var timer = timer2.split(':');
            //by parsing integer, I avoid all extra string processing
            var minutes = parseInt(timer[0], 10);
            var seconds = parseInt(timer[1], 10);
            --seconds;
            minutes = (seconds < 0) ? --minutes : minutes;
            seconds = (seconds < 0) ? 59 : seconds;
            seconds = (seconds < 10) ? '0' + seconds : seconds;
			//minutes = (minutes < 10) ?  minutes : minutes;
            document.getElementById('resendButton').innerHTML ="ارسال مجدد کد " + minutes + ':' + seconds;
            //check if both minutes and seconds are 0
            if ((seconds <= 0) && (minutes <= 0)) {
                clearInterval(interval);
                document.getElementById('resendButton').disabled= false;
                document.getElementById('resendButton').innerHTML ="ارسال مجدد کد";
            }
            timer2 = minutes + ':' + seconds;
        }, 1000);
    }
		},
       
		validations() {
			return{
			oldPassword: {
				required
			},
            password: {
				required,
                minLength: minLength(6)
            },
			confirmPassword: {
                required,
                sameAsPassword: sameAs(this.password)
			},
			registCode: {
                requiredIfFuction : requiredIf(function() { return (this.step==2) }),

			},
            userInput: {
                required
            },
			
		}
		}
	};
</script>


<style>
	.invalid {
		border: 1px solid red !important;
		box-shadow: 0 0 5px red !important;
	}
</style>

